import { render } from "./LbrxInput.vue?vue&type=template&id=6a7f5a4e&scoped=true"
import script from "./LbrxInput.vue?vue&type=script&lang=js"
export * from "./LbrxInput.vue?vue&type=script&lang=js"

import "./LbrxInput.vue?vue&type=style&index=0&id=6a7f5a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7f5a4e"]])

export default __exports__